import useFlowNextStore from '$/store/useTeamFlowStore';
import { useTeamFlowClipperStore } from '../store/useTeamFlowClipperStore';

export interface TeamFlowCanvasReadonlyState {
  inShared: boolean;
  clipperVisible: boolean;
  fullscreenOpen: boolean;
}

export interface TeamFlowCanvasReadonlyOptions {
  ignoreMiniClipper?: boolean;
}

/**
 * 根据分享态与剪辑器占用态计算画布是否只读。
 */
export function resolveTeamFlowCanvasReadonly(
  state: TeamFlowCanvasReadonlyState,
  options?: TeamFlowCanvasReadonlyOptions,
): boolean {
  if (state.inShared || state.fullscreenOpen) return true;
  return options?.ignoreMiniClipper ? false : state.clipperVisible;
}

/**
 * 读取当前 Team Flow 状态并判断画布是否只读。
 */
export function isTeamFlowCanvasReadonly(options?: TeamFlowCanvasReadonlyOptions): boolean {
  const { inShared } = useFlowNextStore.getState();
  const { fullscreenOpen, visible } = useTeamFlowClipperStore.getState();
  return resolveTeamFlowCanvasReadonly({
    inShared,
    clipperVisible: visible,
    fullscreenOpen,
  }, options);
}
